<template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>
            <button :disabled="disabled" v-show="anulado === 'N'" @click="agregarDetalle" type="button" class="btn-success"><i class="fa fa-plus"></i></button>
          </th>
          <th></th>
          <th>Código</th>
          <th>Descripción</th>
          <th>Precio</th>
          <th>Cantidad</th>
          <th>Descuento</th>
          <th>Impuestos</th>
          <th>Total</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in modelValue" :key="(moment(new Date()).format('YYYYMMDDHHmmss')) + index"  v-show="similiarToSearch(row.nombre_item) || similiarToSearch(row.id_item)">
          <th scope="row">
            {{ index + 1 }}
          </th>
          <td>
            <button :disabled="disabled" @click="editarDetalle(index)" class="btn-info btn--text" type="button"><i class="fa fa-edit"></i></button>
          </td>
          <td>
            <input-field readonly :id="'idItem' + index" :value="row.id_item" placeholder="Código">
              <span v-if="erroresFormulario.hasOwnProperty('items.' + index + '.id_item')" class="helper-text text-danger"
                slot="helper">
                <strong>{{ erroresFormulario['items.' + index + '.id_item'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td :tooltip="row.nombre_item!==''?row.nombre_item:'Seleccione...'">
            <input-field readonly :id="'nombreItem' + index" :value="row.nombre_item" placeholder="Nombre"></input-field>
          </td>
          <td>
            <input-field vMoney :format="moneyPersonalizado" readonly :id="'precio' + index" :value="row.precio" placeholder="Precio">
              <span v-if="erroresFormulario.hasOwnProperty('items.' + index + '.precio')" class="helper-text text-danger"
                slot="helper">
                <strong>{{ erroresFormulario['items.' + index + '.precio'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td>
            <input-field vMoney :format="decimalPersonalizado" readonly :id="'cantidad' + index" :value="row.cantidad" placeholder="Precio">
              <span v-if="erroresFormulario.hasOwnProperty('items.' + index + '.cantidad')" class="helper-text text-danger"
                slot="helper">
                <strong>{{ erroresFormulario['items.' + index + '.cantidad'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td>
            <input-field vMoney :format="money" readonly :id="'totalDescuento' + index" :value="row.total_descuento"
              placeholder="Descuento">
              <span v-if="erroresFormulario.hasOwnProperty('items.' + index + '.total_descuento')" class="helper-text text-danger"
                slot="helper">
                <strong>{{ erroresFormulario['items.' + index + '.total_descuento'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td>
            <input-field vMoney :format="money" readonly :id="'totalImpuestos' + index" :value="row.total_impuestos"
              placeholder="Impuestos"></input-field>
          </td>
          <td>
            <input-field vMoney :format="money" readonly :id="'total' + index" :value="row.total" placeholder="Total">
              <span v-if="erroresFormulario.hasOwnProperty('items.' + index + '.total')" class="helper-text text-danger"
                slot="helper">
                <strong>{{ erroresFormulario['items.' + index + '.total'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td>
            <button :disabled="disabled" @click="eliminarDetalle(index)" class="btn-danger btn--text" type="button"><i class="fa fa-trash-o"></i></button>
          </td>
        </tr>
        <tr v-show="modelValue.length === 0">
          <td colspan="9">
            <strong>No se ha agregado detalles en el comprobante.</strong>
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="5">Totales</th>
          <td><strong>Total de cantidades</strong></td>
          <td>{{ totalCantidades }}</td>
          <td><strong>Total ($)</strong></td>
          <td>$ {{ totalItems.toLocaleString(locale) }}</td>
        </tr>
      </tbody>
    </table>
    <modal :clickToClose="false" width="70%" name="itemComprobante" height="auto" scrollable>
      <item-comprobante :grava_iva="grava_iva" :decimales_compras="decimales_compras" :moneyPersonalizado="moneyPersonalizado" :decimalPersonalizado="decimalPersonalizado" :precioEditable="precioEditable" :tipo="tipo" :tipoComprobante="tipoComprobante" :valorIrbpnr="irbpnr" @cancelar="cancelarDetalle" @input="aceptarDetalle" v-model="selectedItem"></item-comprobante>
    </modal>
  </div>
</template>

<script>

export default {
    props : {
      grava_iva: {
        type: Boolean,
        required: false,
        default: true
      },
      decimales_compras: {
        required: false,
        default: 2
      },
        retencionServicios : {
            type : Number, 
            required : false,
            default : 0
        },
        retencionProductos : {
            type : Number, 
            required : false,
            default : 0
        },
        value : {
            type : Array,
            default : function () {
                return [];
            },
            required : false
        },
        irbpnr : {
            type : Number,
            required : true
        },
        errores : {
            type : Object,
            required : true
        },
        tipoComprobante : {
            type : String,
            required : true
        },
        anulado : {
            required : true,
            type : String
        },
        disabled : {
            required : false,
            type : Boolean,
            default : false
        },
        tipo : {
          required : false,
          type : String,
          default : 'E'
        },
        precioEditable : {
          required : false,
          default : true
        },
        search : {
          required : false,
          default : ''
        }
    },
    data : function () {
        return {
          
          moment : moment,
          locale : locale,
            modelValue : this.value,
            selectedItem : {
                id_item : '',
                cantidad : 1,
                precio : 0,
                precio_produccion : 0,
                total_descuento : 0,
                iva : 0,
                ice : 0,
                porcentaje_descuento : 0,
                total : 0,
                nombre_item : '',
                porcentaje_iva : 0,
                porcentaje_ice : 0,
                id_iva : '',
                id_ice : '',
                irbpnr : false,
                detalle : '',
                total_irbpnr : 0,
                detalle : '',
                total_parcial : 0,
                total_impuestos : 0,
                total_inicial : 0,
                tarifa_especifica_ice : 0,
                numero_unidades_ice : 0,
                total_parcial_ice : 0,
                porcentaje_ed_valorem : 0,
                cantidad_ice : 0,
                cantidad_irbpnr : 0,
                valor_subsidio : 0,
                precio_sin_subsidio : 0,
                mostrar_detalle : true
            },
            agregandoNuevo : false,
            erroresFormulario : this.errores,
            money : money,
            money2 : money2,
            decimal : decimal,
            selectedIndex : -1,
            decimalPersonalizado: {
              numeral: true,
              numeralDecimalScale: parseFloat(this.decimales_compras),
              numeralPositiveOnly: true,
              rawValueTrimPrefix: true,
            },
            moneyPersonalizado: {
              numeral: true,
              numeralDecimalScale: parseFloat(this.decimales_compras),
              numeralPositiveOnly: true,
              rawValueTrimPrefix: true,
              prefix: "$ ",
            }
        }
    },
    computed : {
      totalCantidades : function () {
        let cantidades = 0;
        for (let i = 0; i < this.modelValue.length; i++)
        {
          let cantidad = parseFloat(this.modelValue[i].cantidad);
          if (isNaN(cantidad))
            cantidad = 0;
          cantidades += cantidad;
        }
        return cantidades;
      },
      totalItems : function () {
        let items = 0;
        for (let i = 0; i < this.modelValue.length; i++)
        {
          let total = parseFloat(this.modelValue[i].total);
          if (isNaN(total))
            total = 0;
          items += total;
        }
        return round(items);
      }
    },
    methods : {
        similiarToSearch: function(value) {
          let searchItems = this.search;
          if (searchItems === "")
            return true;
          else
            return (
              value.toUpperCase().indexOf(searchItems.toUpperCase()) != -1
            );
        },
        calcularUtilidadFila : function (index, items = null) {
          if (items === null)
            items = this.modelValue;
          let row = items[index];
          let retencion = 0;
          let totalSinImpuestos = parseFloat(row.total_parcial);
          if (isNaN(totalSinImpuestos))
              totalSinImpuestos = 0;
          if (items[index].tipo_item === 'P')
              retencion = round(totalSinImpuestos * (this.retencionProductos / 100));
          else
              retencion = round(totalSinImpuestos * (this.retencionServicios / 100));
          let precio = parseFloat(row.precio);
          let coste = parseFloat(row.coste);
          let cantidad = parseFloat(row.cantidad);
          if (isNaN(cantidad))
              cantidad = 0;
          if (isNaN(precio))
              precio = 0;
          if (isNaN(coste))
              coste = 0;
          let descuento = parseFloat(row.total_descuento);
          if (isNaN(descuento))
              descuento = 0;
          let costeTotal = (coste * cantidad);
          let precioTotal = (precio * cantidad);
          let diferencia = precioTotal - descuento - costeTotal - retencion;
          row.margen_utilidad = round(diferencia);
        },
        agregarDetalle : function () {
            this.agregandoNuevo = true;
            let item = {
                margen_utilidad : 0,
                coste : 0,
                id_item : '',
                cantidad : 1,
                precio : 0,
                precio_produccion : 0,
                total_descuento : 0,
                iva : 0,
                ice : 0,
                porcentaje_descuento : 0,
                total : 0,
                nombre_item : '',
                porcentaje_iva : 0,
                porcentaje_ice : 0,
                id_iva : '',
                id_ice : '',
                irbpnr : false,
                detalle : '',
                total_irbpnr : 0,
                detalle : '',
                total_parcial : 0,
                total_impuestos : 0,
                total_inicial : 0,
                tarifa_especifica_ice : 0,
                numero_unidades_ice : 0,
                total_parcial_ice : 0,
                porcentaje_ed_valorem : 0,
                cantidad_ice : 0,
                cantidad_irbpnr : 0,
                mostrar_detalle : true,
                tipo_item : ''
            };
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.selectedIndex = this.modelValue.push(item) - 1;
            this.$modal.show('itemComprobante');
        },
        editarDetalle : function (index) {
            this.selectedIndex = index;
            this.agregandoNuevo = false;
            this.selectedItem = JSON.parse(JSON.stringify(this.modelValue[index]));
            this.$modal.show('itemComprobante');
        },
        eliminarDetalle : function (index) {
            swal({
                    title: '¿Deseas eliminar este detalle?',
                    text: "Esta acción requiere de confirmación.",
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Eliminar',
                    cancelButtonText : 'No'
                }).then((result) => {
                    if (result.value)
                        this.modelValue.splice(index, 1);      
                    this.$emit('input', this.modelValue);
                });
        },
        aceptarDetalle : function (detalle) {
            this.agregandoNuevo = false;
            this.modelValue.splice(this.selectedIndex, 1, detalle);
            this.$modal.hide('itemComprobante');
            this.calcularUtilidadFila(this.selectedIndex);
            this.$emit('input', this.modelValue);
            this.selectedIndex = -1;
        },
        cancelarDetalle : function () {
            if (this.agregandoNuevo) {
                this.modelValue.splice(this.modelValue.indexOf(this.selectedItem), 1);
                this.$emit('input', this.modelValue);
            }
            this.agregandoNuevo = false;
            this.$modal.hide('itemComprobante');
            
        }
    },
    watch : {
      decimales_compras:  function (value){
        this.decimalPersonalizado.numeralDecimalScale = parseFloat(value);
        this.moneyPersonalizado.numeralDecimalScale = parseFloat(value);
      },
        value : function (value) {
            this.modelValue = value;
        },
        errores : function (value) {
            this.erroresFormulario = value;
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaDetalleComprobante.vue